import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ViewCvComponent} from '../view-cv/view-cv.component';
import { JobsOffersApplicant } from '../../models/jobs-offers-applicant';
import { SliderMapCvComponent} from '../slider-map-cv/slider-map-cv.component';
//import { SliderCvComponent} from '../slider-cv/slider-cv.component';
import { Constants } from '../constants';
import { InviteService } from '../../services/invite.service';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ItemInviteUserDetailDialogComponent } from '../item-invite-user-detail-dialog/item-invite-user-detail-dialog.component';
import { CvMapComponent } from '../cv-map/cv-map.component';
import { ProfileNoLocationStore } from '../state/profile-no-location.store';

@Component({
  selector: 'app-item-candidate-recommended',
  templateUrl: './item-candidate-recommended.component.html',
  styleUrls: ['./item-candidate-recommended.component.css']
})
export class ItemCandidateRecommendedComponent implements OnInit {
  @Input() user;
  @Input() index;
  @Input() recommen;
  @Input() check_mandatory;
  @Input() job;
  @Input() requirement: boolean;
  publicating: boolean = false;
  errorMessage: string;


  selectedOption;

  public STATUS = Constants;

  constructor(
    public dialog: MdDialog,
    public profileNoLocationStore: ProfileNoLocationStore,
    private inviteService:InviteService) { 
    if (this.check_mandatory!=undefined) {
      this.check_mandatory = true;
    }
  }

  ngOnInit() {
  }


  openCV (userId){
    let dialogRef = this.dialog.open(ViewCvComponent, {
      data: {userId:userId, job: this.job
    }});

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }

  onPostReInvite() {
    if (this.job.status !== -4) {
      let listInvitations = [];
      listInvitations.push({
        email: this.user.email,
        job_id: this.job.id
      });

      this.inviteService.postReInvite(listInvitations, true)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors : string = error;
          let jsonErrors : any =  [];          
          jsonErrors =  JSON.parse(txterrors).errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {                                                
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                }
                txterrors = txterrors+"<p class='bg-danger'>"+element.row+" ("+txterr+")</p>";              
                //txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>"; 
            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
          }
          this.publicating = false;
          this.errorMessage = <any>error
          
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
    }
  }

  //noinspection JSMethodCanBeStatic
  percMandatory(user): number {
    if (user.apply != undefined) {
      if(user.apply.mandatoryrequirements > 0) {
        return Math.floor(user.apply.mandatoryrequirementsmet / user.apply.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.mandatoryrequirements > 0) {
        return Math.floor(user.mandatoryrequirementsmet / user.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  percDesirable(user): number {
    if (user.apply != undefined) {
      if(user.apply.desirablerequirements > 0) {
        return Math.floor(user.apply.desirablerequirementsmet / user.apply.desirablerequirements * 100);
      } else {
        return 0;
      }
    } else {
      if(user.desirablerequirements > 0) {
        return Math.floor(user.desirablerequirementsmet / user.desirablerequirements * 100);
      } else {
        return 0;
      }
    }
  }

  openDetailDialog(user) {
    if (this.job.status !== -4) {
      let dialogRef = this.dialog.open(ItemInviteUserDetailDialogComponent, {
        data: {user: user}
      });
    }
  }

  openCVMap (user) {

    let dialogRef = this.dialog.open(SliderMapCvComponent, {
      data: {selected:user, map:false, filters: this.job, filter: this.recommen, reco: true}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });

    // if (this.job.status !== -4) {
    //   this.dialog.open(CvMapComponent, {
    //     data: {userId: user.id, filters: this.job, recs: 0}
    //   });
    // }
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidate-recommended/item-candidate-recommended.component.ts